import React from 'react';
import Logo from 'components/UI/Logo/Logo';
import Footers from 'components/Footer/Footer';
import { Link } from 'react-router-dom';
import LogoImage from 'assets/images/logo-alt.svg';
import FooterMenu from './FooterMenu';

const Footer = () => {
  return (
    <Footers
      logo={
        <Link to="/">
          <Logo src={LogoImage} title="hotel" />
        </Link>
      }
      menu={<FooterMenu />}
      copyright={`Copyright @ ${new Date().getFullYear()} RedQ, Inc.`}
    />
  );
};

export default Footer;
